import { useQuery } from '@tanstack/react-query'

import { HARDCODED_PUBLIC_GAMES } from '#/constants'

const defaultPagination = {
  lastPage: 1,
  totalRows: 0,
  desc: false,
  pageSize: 18,
  page: 1,
}
const defaultResponse = { data: [], pagination: defaultPagination }

type Options = {
  enabled?: boolean
}

export type GameV3Query = Record<string, Array<string> | string | number>

export const publicGamesKeysV3 = {
  all: ['public_games_v3'] as const,
  filter: (query: GameV3Query) => [...publicGamesKeysV3.all, query] as const,
}
export const usePublicGamesV3 = (query: GameV3Query, options?: Options) => {
  return useQuery({
    queryKey: publicGamesKeysV3.filter(query),
    queryFn: () => HARDCODED_PUBLIC_GAMES,
    enabled: options?.enabled,
  })
}
